(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ee-homepage-hero-slider"] && !Shopify.designMode) return;
  try {
    
  (() => {
    function initHeroSliders() {
      const sliderSections = document.querySelectorAll('.rag-hhs');
      if (!sliderSections.length) return;

      sliderSections.forEach((sectionNode) => {
        if (sectionNode.dataset.sliderInitialized === 'true') return;
        sectionNode.dataset.sliderInitialized = 'true';

        const track = sectionNode.querySelector('.rag-hhs__track');
        const slides = Array.from(sectionNode.querySelectorAll('.rag-hhs__slide'));
        if (!track || !slides.length) return;

        const prevBtn = sectionNode.querySelector('[data-role="prev"]');
        const nextBtn = sectionNode.querySelector('[data-role="next"]');
        const dotsWrapper = sectionNode.querySelector('.rag-hhs__dots');

        if (slides.length <= 1) {
          if (prevBtn) prevBtn.style.display = 'none';
          if (nextBtn) nextBtn.style.display = 'none';
          if (dotsWrapper) dotsWrapper.style.display = 'none';
          return;
        }

        if (prevBtn) prevBtn.style.display = 'block';
        if (nextBtn) nextBtn.style.display = 'block';

        if (dotsWrapper) {
          dotsWrapper.innerHTML = '';

          slides.forEach((slide, index) => {
            const dot = document.createElement('button');
            dot.type = 'button';
            dot.className = 'rag-hhs__dot' + (index === 0 ? ' is-active' : '');
            dot.setAttribute('aria-label', 'Go to slide ' + (index + 1));
            dot.dataset.index = index;
            dotsWrapper.appendChild(dot);
          });

          dotsWrapper.style.display = 'flex';
        }

        const dots = Array.from(sectionNode.querySelectorAll('.rag-hhs__dot'));
        let currentIndex = 0;

        const autoplayEnabled = sectionNode.dataset.autoplay === 'true';
        const autoplaySpeedSeconds = parseInt(sectionNode.dataset.autoplaySpeed || '5', 10) || 5;
        const autoplayDelay = autoplaySpeedSeconds * 1000;
        let autoplayTimer = null;

        function goToSlide(index) {
          currentIndex = (index + slides.length) % slides.length;
          track.style.transform = 'translateX(-' + currentIndex * 100 + '%)';

          dots.forEach((dot, i) => {
            dot.classList.toggle('is-active', i === currentIndex);
          });
        }

        function nextSlide() {
          goToSlide(currentIndex + 1);
        }

        function prevSlide() {
          goToSlide(currentIndex - 1);
        }

        function startAutoplay() {
          if (!autoplayEnabled || autoplayTimer) return;
          autoplayTimer = setInterval(nextSlide, autoplayDelay);
        }

        function stopAutoplay() {
          if (!autoplayTimer) return;
          clearInterval(autoplayTimer);
          autoplayTimer = null;
        }

        if (nextBtn) {
          nextBtn.addEventListener('click', () => {
            stopAutoplay();
            nextSlide();
            startAutoplay();
          });
        }

        if (prevBtn) {
          prevBtn.addEventListener('click', () => {
            stopAutoplay();
            prevSlide();
            startAutoplay();
          });
        }

        dots.forEach((dot) => {
          dot.addEventListener('click', () => {
            stopAutoplay();
            goToSlide(parseInt(dot.dataset.index, 10));
            startAutoplay();
          });
        });

        sectionNode.addEventListener('mouseenter', stopAutoplay);
        sectionNode.addEventListener('mouseleave', startAutoplay);

        goToSlide(0);
        startAutoplay();
      });
    }

    document.addEventListener('DOMContentLoaded', initHeroSliders);
    document.addEventListener('shopify:section:load', initHeroSliders);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sl-offer-bar"] && !Shopify.designMode) return;
  try {
    
    window.addEventListener('load', (event) => {
        const thisBar = document.querySelector('.shoplift-offer--bar--sticky');

        if (thisBar != null) {
            const thisHeader = document.querySelector('.shoplift-offerbar-wrapper');
            thisHeader.classList.add("shoplift-offer-bar-sticky");

            const mainHeader = document.querySelector('#shopify-section-header > sticky-header');

            const mainInitialTop = mainHeader.offsetTop;
            const stickyStart = mainHeader ? (mainHeader.offsetTop + mainHeader.clientHeight) : 0;
            let lastScroll = window.scrollY;
            document.addEventListener("scroll", (scrollEvent) => {
                if (!thisHeader) return;

                // Do it quick and dirty
                const mainHidden = mainHeader && (window.scrollY > lastScroll);
                lastScroll = window.scrollY;

                const makeSticky = window.pageYOffset > stickyStart || mainHeader && window.pageYOffset > mainInitialTop && mainHeader.parentElement.classList.contains("shopify-section-header-sticky");

                thisHeader.classList.toggle("shoplift-offer-bar-sticky", makeSticky);

                if (!makeSticky) return;

                let topPosition = 0;

                if (mainHeader && !mainHidden)
                    topPosition += mainHeader.clientHeight;

                thisHeader.style.top = topPosition + "px";
            });
        }
    });

  } catch(e) { console.error(e); }
})();
})();
